'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/vue-msal/~/axios/lib/cancel/isCancel.js
// module id = 182
// module chunks = 0